// extracted by mini-css-extract-plugin
export default {"results-list-container":"ResultsList_results-list-container__mhaD6","results-table":"ResultsList_results-table__LrzmU"};